// Intent banner (First/Exit) constants.
//
// Supix generic-category context `0006` — registered in the KB at
// kb/guides/supix-generic-category-events.md (anti-collision source of truth).
// Fired via sendSupixEvent('/car', { category, user_id, utm_campaign }).
const INTENT_BANNER = {
  // /ads type params (matches AdType 18/19 on the backend).
  AD_TYPE: {
    FIRST: 'FIRST_INTENT_AD',
    EXIT: 'EXIT_INTENT_AD',
  },
  // Group keys in the (camelCased) /ads response, derived from the type name.
  RESPONSE_KEY: {
    FIRST: 'firstIntentAd',
    EXIT: 'exitIntentAd',
  },
  // Supix faixa 0006 — view / go-to-store (CTA) / dismiss per intent.
  SUPIX: {
    FIRST: {
      VIEW: 100060101,
      CTA: 100060102,
      DISMISS: 100060103,
    },
    EXIT: {
      VIEW: 100060201,
      CTA: 100060202,
      DISMISS: 100060203,
    },
  },
  // Safe defaults applied when smartbanner_obj.intent is absent or partial.
  DEFAULTS: {
    FIRST: {
      desktopDelayMs: 3000,
      mobileMinScrollPx: 100,
      mobileDelayMs: 4000,
    },
    EXIT: {
      desktopMinDwellMs: 10000,
      mobileScrollUpAfterPct: 50,
      mobileMinDwellMs: 15000,
    },
    FREQUENCY: {
      perDay: 1,
      perCampaign: 3,
      cooldownH: 24,
      stopAfterCtaClick: true,
      oncePerSessionAfterDismiss: true,
    },
  },
};

export const INTENT_TYPES = {
  FIRST: 'first',
  EXIT: 'exit',
};

export default INTENT_BANNER;
